
import { defineComponent, PropType, watch, ref } from "vue";

export default defineComponent({
  props: {
    more: {
      type: Boolean,
      default: false,
    },
    /**
     * 是否默认展开
     */
    defaultExpandAll: {
      type: Boolean,
      default: true,
    },
    /**
     * 选中树的值
     */
    modelValue: {
      type: [String, Number],
      default: "",
    },
    /**
     * 选中树的值
     */
    level: {
      type: Number,
      default: 5,
    },

    /**
     * data
     */
    data: {
      type: Array as PropType<any[]>,
      default: (): any[] => [],
    },

    /**
     * props 配置
     */
    props: {
      type: Object,
      default: () => {
        return {};
      },
    },

    /**
     *
     */
    nodeKey: {
      type: String,
      default: "id",
    },
  },
  setup(prop) {
    // 树形组件ref
    const tree: any = ref({});

    // 监听modelValue
    watch(
      () => prop.modelValue,
      (val) => {
        if (val.toString()) {
          tree.value.setCurrentKey(val);
        } else {
          tree.value.setCurrentKey(null);
        }
      }
    );

    return {
      tree,
    };
  },
  methods: {
    nodeClick(data: any, e: any) {
      this.$emit("update:modelValue", data[this.nodeKey]);
      this.$emit("nodeClick", data, e);
    },
    commandFn(data: any) {
      this.$emit("commandClick", data);
    },
  },
});
